const initialState = {
  currencyAllData: [],
  loading: true,
};

const currencyAllReducer = (state = initialState, action) => {
  switch (action.type) {
    case "getCurrencyAll":
      return {
        ...state,
        currencyAllData: action.payload,
        loading: false,
      };

    case "createCurrencyAll":
      return {
        ...state,
        currencyAllData: action.payload,
        loading: false,
      };

    case "updateCurrencyAll":
      return {
        ...state,
        currencyAllData: action.payload,
        loading: false,
      };

    default:
      return state;
  }
};

export default currencyAllReducer;
